// src/pages/auth/Register.js
import React from 'react';
import RegisterForm from '../../components/forms/RegisterForm';

const Register = () => {
  return   <RegisterForm />
}

export default Register;